/* import __COLOCATED_TEMPLATE__ from './setup-your-subscriptions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();